"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ButtonInternals;
var React = _interopRequireWildcard(require("react"));
var ReactIs = _interopRequireWildcard(require("react-is"));
var _styledComponents = require("./styled-components");
var _utils = require("./utils");
var _overrides = require("../helpers/overrides");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// @ts-ignore
function RenderEnhancer(props) {
  const {
    Enhancer,
    ...restProps
  } = props;
  if (typeof Enhancer === 'string') {
    return Enhancer;
  }
  if (ReactIs.isValidElementType(Enhancer)) {
    return /*#__PURE__*/React.createElement(Enhancer, restProps);
  }
  return Enhancer;
}
function ButtonInternals(props) {
  const {
    children,
    overrides = {},
    startEnhancer,
    endEnhancer
  } = props;
  const [StartEnhancer, startEnhancerProps] = (0, _overrides.getOverrides)(overrides.StartEnhancer, _styledComponents.StartEnhancer);
  const [EndEnhancer, endEnhancerProps] = (0, _overrides.getOverrides)(overrides.EndEnhancer, _styledComponents.EndEnhancer);
  const sharedProps = (0, _utils.getSharedProps)(props);
  const content = /*#__PURE__*/React.createElement(React.Fragment, null, startEnhancer !== null && startEnhancer !== undefined && /*#__PURE__*/React.createElement(StartEnhancer, _extends({}, sharedProps, startEnhancerProps), /*#__PURE__*/React.createElement(RenderEnhancer, {
    Enhancer: startEnhancer
  })), children, endEnhancer !== null && endEnhancer !== undefined && /*#__PURE__*/React.createElement(EndEnhancer, _extends({}, sharedProps, endEnhancerProps), /*#__PURE__*/React.createElement(RenderEnhancer, {
    Enhancer: endEnhancer
  })));
  if (props.isLoading) {
    const hiddenStyle = {
      opacity: 0,
      display: 'flex',
      height: '0px'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: hiddenStyle
    }, content);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, content);
}